import { render, staticRenderFns } from "./TextSeparator.vue?vue&type=template&id=10ea8912&scoped=true&"
import script from "./TextSeparator.vue?vue&type=script&lang=js&"
export * from "./TextSeparator.vue?vue&type=script&lang=js&"
import style0 from "./TextSeparator.vue?vue&type=style&index=0&id=10ea8912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ea8912",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
